/* eslint-disable linebreak-style */
// production data management
export const FETCH_ASSEMBLY_DATA = '@@production/fetch-assembly-data';
export const SET_ASSEMBLY_DATA = '@@production/set-assembly-data';
export const SET_ASSEMBLY_DATA_FAILURE = '@@production/set-assembly-data-failure';
export const CLEAR_ASSEMBLY_DATA = '@@production/clear-assembly-data';

export const FETCH_ASSEMBLY_DETAILS = '@@production/fetch-assembly-details';
export const SET_ASSEMBLY_DETAILS = '@@production/set-assembly-details';
export const SET_ASSEMBLY_DETAILS_FAILURE = '@@production/set-assembly-details-failure';
export const CLEAR_ASSEMBLY_DETAILS = '@@production/clear-assembly-details';

export const UPLOAD_NDT_DOCUMENT = '@@production/upload-ndt-document';
export const SET_NDT_UPLOAD_SUCCESS = '@@production/set-ndt-upload-success';
export const SET_NDT_UPLOAD_FAILURE = '@@production/set-ndt-upload-failure';

export const UPDATE_ASSEMBLY_STATUS = '@@production/update-assembly-status';
export const SET_ASSEMBLY_STATUS_SUCCESS = '@@production/set-assembly-status-success';
export const SET_ASSEMBLY_STATUS_FAILURE = '@@production/set-assembly-status-failure';

export const FETCH_ASSEMBLY_FILTERS = '@@production/fetch-assembly-filters';
export const SET_ASSEMBLY_FILTERS = '@@production/set-assembly-filters';
export const SET_ASSEMBLY_FILTERS_FAILURE = '@@production/set-assembly-filters-failure';

// Fitment Data Management
export const UPDATE_ASSEMBLY_FITMENT = '@@production/update-assembly-fitment';
export const SET_ASSEMBLY_FITMENT_SUCCESS = '@@production/set-assembly-fitment-success';
export const SET_ASSEMBLY_FITMENT_FAILURE = '@@production/set-assembly-fitment-failure';

// GPS Data Management
export const FETCH_GPS_DATA = '@@production/fetch-gps-data';
export const SET_GPS_DATA = '@@production/set-gps-data';
export const SET_GPS_DATA_FAILURE = '@@production/set-gps-data-failure';
export const CLEAR_GPS_DATA = '@@production/clear-gps-data'; 
// Visual Inspection Data Management
export const UPDATE_ASSEMBLY_VISUAL_INSPECTION = '@@production/update-assembly-visual-inspection';
export const SET_ASSEMBLY_VISUAL_INSPECTION_SUCCESS = '@@production/set-assembly-visual-inspection-success';
export const SET_ASSEMBLY_VISUAL_INSPECTION_FAILURE = '@@production/set-assembly-visual-inspection-failure';

// Alignment Data Management
export const UPDATE_ASSEMBLY_ALIGNMENT = '@@production/update-assembly-alignment';
export const SET_ASSEMBLY_ALIGNMENT_SUCCESS = '@@production/set-assembly-alignment-success';
export const SET_ASSEMBLY_ALIGNMENT_FAILURE = '@@production/set-assembly-alignment-failure';

// Production Data Management
export const FETCH_PRODUCTION_DATA = '@@production/fetch-production-data';
export const SET_PRODUCTION_DATA = '@@production/set-production-data';
export const SET_PRODUCTION_DATA_FAILURE = '@@production/set-production-data-failure';
export const CLEAR_PRODUCTION_DATA = '@@production/clear-production-data';

// Team Members Management
export const GET_ALL_TEAM_MEMBERS = '@@production/get-all-team-members';
export const SET_TEAM_MEMBERS = '@@production/set-team-members';
export const SET_TEAM_MEMBERS_FAILURE = '@@production/set-team-members-failure';
export const CLEAR_TEAM_MEMBERS = '@@production/clear-team-members'; 

// Status Configuration and Limits Data
export const FETCH_LIMITS_DATA = 'FETCH_LIMITS_DATA';
export const SET_LIMITS_DATA = 'SET_LIMITS_DATA';
export const SET_LIMITS_DATA_FAILURE = 'SET_LIMITS_DATA_FAILURE';
export const CLEAR_LIMITS_DATA = 'CLEAR_LIMITS_DATA';

export const UPDATE_STATUS_CONFIGURATION = 'UPDATE_STATUS_CONFIGURATION';
export const SET_STATUS_CONFIGURATION_SUCCESS = 'SET_STATUS_CONFIGURATION_SUCCESS';
export const SET_STATUS_CONFIGURATION_FAILURE = 'SET_STATUS_CONFIGURATION_FAILURE';

// Weld Parameters Management
export const FETCH_WELD_PARAMETERS = '@@production/fetch-weld-parameters';
export const SET_WELD_PARAMETERS = '@@production/set-weld-parameters';
export const SET_WELD_PARAMETERS_FAILURE = '@@production/set-weld-parameters-failure';
export const CLEAR_WELD_PARAMETERS = '@@production/clear-weld-parameters';
export const SET_WELD_PARAMETERS_MODAL_OPEN = '@@production/set-weld-parameters-modal-open';

// Fitment Report Download Management
export const DOWNLOAD_FITMENT_REPORT = '@@production/download-fitment-report';
export const SET_FITMENT_REPORT_DOWNLOAD_SUCCESS = '@@production/set-fitment-report-download-success';
export const SET_FITMENT_REPORT_DOWNLOAD_FAILURE = '@@production/set-fitment-report-download-failure';
export const CLEAR_FITMENT_REPORT_DOWNLOAD = '@@production/clear-fitment-report-download'; 

// Visual Inspection Report Download Management
export const DOWNLOAD_VISUAL_INSPECTION_REPORT = '@@production/download-visual-inspection-report';
export const SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_SUCCESS = '@@production/set-visual-inspection-report-download-success';
export const SET_VISUAL_INSPECTION_REPORT_DOWNLOAD_FAILURE = '@@production/set-visual-inspection-report-download-failure';
export const CLEAR_VISUAL_INSPECTION_REPORT_DOWNLOAD = '@@production/clear-visual-inspection-report-download';

// Alignment Report Download Management
export const DOWNLOAD_ALIGNMENT_REPORT = '@@production/download-alignment-report';
export const SET_ALIGNMENT_REPORT_DOWNLOAD_SUCCESS = '@@production/set-alignment-report-download-success';
export const SET_ALIGNMENT_REPORT_DOWNLOAD_FAILURE = '@@production/set-alignment-report-download-failure';
export const CLEAR_ALIGNMENT_REPORT_DOWNLOAD = '@@production/clear-alignment-report-download';

// Production Sheet Merged Report Download Management
export const DOWNLOAD_PRODUCTION_SHEET_MERGED_REPORT = '@@production/download-production-sheet-merged-report';
export const SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_SUCCESS = '@@production/set-production-sheet-merged-report-download-success';
export const SET_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD_FAILURE = '@@production/set-production-sheet-merged-report-download-failure';
export const CLEAR_PRODUCTION_SHEET_MERGED_REPORT_DOWNLOAD = '@@production/clear-production-sheet-merged-report-download';

// NDT Indication Log Management
export const FETCH_NDT_INDICATION_LOGS = '@@production/fetch-ndt-indication-logs';
export const SET_NDT_INDICATION_LOGS = '@@production/set-ndt-indication-logs';
export const SET_NDT_INDICATION_LOGS_FAILURE = '@@production/set-ndt-indication-logs-failure';
export const CLEAR_NDT_INDICATION_LOGS = '@@production/clear-ndt-indication-logs';
export const CREATE_NDT_REPAIR_LOG = '@@production/create-ndt-repair-log';
export const SET_CREATE_NDT_REPAIR_LOG_SUCCESS = '@@production/set-create-ndt-repair-log-success';
export const SET_CREATE_NDT_REPAIR_LOG_FAILURE = '@@production/set-create-ndt-repair-log-failure';
export const UPDATE_NDT_REPAIR_LOG = '@@production/update-ndt-repair-log';
export const SET_UPDATE_NDT_REPAIR_LOG_SUCCESS = '@@production/set-update-ndt-repair-log-success';
export const SET_UPDATE_NDT_REPAIR_LOG_FAILURE = '@@production/set-update-ndt-repair-log-failure';
export const DELETE_NDT_REPAIR_LOG = '@@production/delete-ndt-repair-log';
export const SET_DELETE_NDT_REPAIR_LOG_SUCCESS = '@@production/set-delete-ndt-repair-log-success';
export const SET_DELETE_NDT_REPAIR_LOG_FAILURE = '@@production/set-delete-ndt-repair-log-failure';

// NDT Repair Log Document Management
export const FETCH_NDT_REPAIR_LOG_DOC = '@@production/fetch-ndt-repair-log-doc';
export const SET_NDT_REPAIR_LOG_DOC = '@@production/set-ndt-repair-log-doc';
export const SET_NDT_REPAIR_LOG_DOC_FAILURE = '@@production/set-ndt-repair-log-doc-failure';
export const UPLOAD_NDT_REPAIR_LOG_DOC = '@@production/upload-ndt-repair-log-doc';
export const SET_NDT_REPAIR_LOG_DOC_SUCCESS = '@@production/set-ndt-repair-log-doc-success';
export const CLEAR_NDT_REPAIR_LOG_DOC = '@@production/clear-ndt-repair-log-doc';

// NDT Indication Log Categories (filter dropdowns)
export const FETCH_NDT_CATEGORIES = '@@production/fetch-ndt-categories';
export const SET_NDT_CATEGORIES = '@@production/set-ndt-categories';
export const SET_NDT_CATEGORIES_FAILURE = '@@production/set-ndt-categories-failure';

// ARK Registry Document Management
export const FETCH_ARK_REGISTRY_DOCS = '@@production/fetch-ark-registry-docs';
export const SET_ARK_REGISTRY_DOCS = '@@production/set-ark-registry-docs';
export const SET_ARK_REGISTRY_DOCS_FAILURE = '@@production/set-ark-registry-docs-failure';
export const UPLOAD_ARK_REGISTRY_DOC = '@@production/upload-ark-registry-doc';
export const SET_ARK_REGISTRY_DOC_SUCCESS = '@@production/set-ark-registry-doc-success';
export const DELETE_ARK_REGISTRY_DOC = '@@production/delete-ark-registry-doc';
export const SET_DELETE_ARK_REGISTRY_DOC_SUCCESS = '@@production/set-delete-ark-registry-doc-success';
export const SET_DELETE_ARK_REGISTRY_DOC_FAILURE = '@@production/set-delete-ark-registry-doc-failure';
export const CLEAR_ARK_REGISTRY_DOCS = '@@production/clear-ark-registry-docs';
export const GET_ARK_REGISTRY_DOWNLOAD_URL = '@@production/get-ark-registry-download-url';
export const SET_ARK_REGISTRY_DOWNLOAD_URL = '@@production/set-ark-registry-download-url';
export const GET_ARK_REGISTRY_PRESIGNED_URL = '@@production/get-ark-registry-presigned-url';
export const SET_ARK_REGISTRY_PRESIGNED_URL = '@@production/set-ark-registry-presigned-url';

// Project Production Sheet Report Generation Management
export const GENERATE_PROJECT_PRODUCTION_SHEET_REPORT = '@@production/generate-project-production-sheet-report';
export const SET_PROJECT_PRODUCTION_SHEET_REPORT_SUCCESS = '@@production/set-project-production-sheet-report-success';
export const SET_PROJECT_PRODUCTION_SHEET_REPORT_FAILURE = '@@production/set-project-production-sheet-report-failure';
export const CLEAR_PROJECT_PRODUCTION_SHEET_REPORT = '@@production/clear-project-production-sheet-report';

// Production Sheet Main Report Download Management
export const DOWNLOAD_PRODUCTION_SHEET_MAIN_REPORT = '@@production/download-production-sheet-main-report';
export const SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_SUCCESS = '@@production/set-production-sheet-main-report-download-success';
export const SET_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD_FAILURE = '@@production/set-production-sheet-main-report-download-failure';
export const CLEAR_PRODUCTION_SHEET_MAIN_REPORT_DOWNLOAD = '@@production/clear-production-sheet-main-report-download';

// Generate Weld Report for Assembly
export const GENERATE_REPORT_ASSEMBLY = '@@production/generate-report-assembly';
export const SET_GENERATE_REPORT_ASSEMBLY_SUCCESS = '@@production/set-generate-report-assembly-success';
export const SET_GENERATE_REPORT_ASSEMBLY_FAILURE = '@@production/set-generate-report-assembly-failure';
export const CLEAR_GENERATE_REPORT_ASSEMBLY = '@@production/clear-generate-report-assembly';

// Inspection Release Note (IRN) Report Generation
export const GENERATE_IRN_REPORT = '@@production/generate-irn-report';
export const SET_IRN_REPORT_SUCCESS = '@@production/set-irn-report-success';
export const SET_IRN_REPORT_FAILURE = '@@production/set-irn-report-failure';
export const CLEAR_IRN_REPORT = '@@production/clear-irn-report';

// Get IRN Report Versions (all pipes for a project)
export const GET_IRN_REPORT_VERSIONS = '@@production/get-irn-report-versions';
export const GET_IRN_REPORT_VERSIONS_SUCCESS = '@@production/get-irn-report-versions-success';
export const GET_IRN_REPORT_VERSIONS_FAILURE = '@@production/get-irn-report-versions-failure';

// Get Production Report Versions (all pipes for a project)
export const GET_PRODUCTION_REPORT_VERSIONS = '@@production/get-production-report-versions';
export const GET_PRODUCTION_REPORT_VERSIONS_SUCCESS = '@@production/get-production-report-versions-success';
export const GET_PRODUCTION_REPORT_VERSIONS_FAILURE = '@@production/get-production-report-versions-failure';

// Generate Project Report (merge all approved reports)
export const GENERATE_PROJECT_REPORT = '@@production/generate-project-report';
export const GENERATE_PROJECT_REPORT_SUCCESS = '@@production/generate-project-report-success';
export const GENERATE_PROJECT_REPORT_FAILURE = '@@production/generate-project-report-failure';
export const CLEAR_GENERATE_PROJECT_REPORT = '@@production/clear-generate-project-report';

// Get Project Report Versions
export const GET_PROJECT_REPORT_VERSIONS = '@@production/get-project-report-versions';
export const GET_PROJECT_REPORT_VERSIONS_SUCCESS = '@@production/get-project-report-versions-success';
export const GET_PROJECT_REPORT_VERSIONS_FAILURE = '@@production/get-project-report-versions-failure';

// Delete Repair Weld Management
export const DELETE_REPAIR_WELD = '@@production/delete-repair-weld';
export const SET_DELETE_REPAIR_WELD_SUCCESS = '@@production/set-delete-repair-weld-success';
export const SET_DELETE_REPAIR_WELD_FAILURE = '@@production/set-delete-repair-weld-failure';
export const CLEAR_DELETE_REPAIR_WELD = '@@production/clear-delete-repair-weld';

// Production Sheet Save Signature Management
export const PRODUCTION_SHEET_SAVE_SIGNATURE = '@@production/production-sheet-save-signature';
export const SET_PRODUCTION_SHEET_SAVE_SIGNATURE_SUCCESS = '@@production/set-production-sheet-save-signature-success';
export const SET_PRODUCTION_SHEET_SAVE_SIGNATURE_FAILURE = '@@production/set-production-sheet-save-signature-failure';
export const CLEAR_PRODUCTION_SHEET_SAVE_SIGNATURE = '@@production/clear-production-sheet-save-signature'; 
